module.exports = __webpack_public_path__ + "static/brand-color-c2be40350e3ee027aff8ce76745af6ef.svg";